import { __assign } from "tslib";
import React from 'react';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import useBaseComponent from '../internal/hooks/use-base-component';
import InternalTiles from './internal';
export default function Tiles(props) {
    var baseComponentProps = useBaseComponent('Tiles');
    return React.createElement(InternalTiles, __assign({}, props, baseComponentProps));
}
applyDisplayName(Tiles, 'Tiles');
//# sourceMappingURL=index.js.map